import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link, NavLink } from 'react-router-dom';
import MenuHeadItem from './menu_HeadItem';
// import { IconCalendar } from '@tabler/icons-react';
import { useHistory } from 'react-router-dom';
const Menu = (props) => {
    const [expandedManuItem, setExpandedManuItem] = useState({
        pulpit: true,
        first: false,
        secund: false,
        third: false,
        fourth: false,
    });
    const history = useHistory();


    const iconMyData = (
        <svg  width="18" height="20" viewBox="0 -2 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M7.67267 1.05015L1.14736 5.86314C1.01136 5.96343 0.941336 6.09781 0.941336 6.26743V14.5482C0.941336 14.8371 1.18579 15.0586 1.47468 15.0586H5.11105L5.11099 9.06413C5.11099 8.80422 5.32165 8.59351 5.58161 8.59351H10.4187C10.6786 8.59351 10.8894 8.80416 10.8894 9.06413V15.0586H14.5257C14.8145 15.0586 15.0591 14.8371 15.0591 14.5482L15.059 6.26743C15.059 6.09764 14.989 5.96343 14.853 5.86314L8.32739 1.0503C8.13021 0.90493 7.86991 0.90493 7.67274 1.0503L7.67267 1.05015ZM6.05205 15.0584V9.53462H9.94798V15.0584H6.05205ZM0.592233 5.10565L7.1177 0.292806C7.64694 -0.097602 8.35291 -0.097602 8.88233 0.292806L15.4078 5.10565C15.7877 5.3858 16 5.79721 16 6.26724V14.548C16 15.3507 15.331 15.9996 14.5255 15.9996H1.47456C0.66905 15.9996 5.78716e-05 15.3503 5.78716e-05 14.548L0 6.26724C0.000173618 5.7972 0.212271 5.38598 0.592205 5.10565H0.592233Z"  fill="#CC0033"/>
</svg>

            // <svg
            //     fill="#fff"
            //     stroke={expandedManuItem.pulpit?"#cc0033":"currentColor"}
            //     strokeWidth="1.5"
            //     viewBox="0 0 24 24"
            //     xmlns="http://www.w3.org/2000/svg"
            //     aria-hidden="true"
            // >
            //     <path
            //         strokeLinecap="round"
            //         strokeLinejoin="round"
            //         d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
            //     ></path>
            // </svg>
    );

    const iconContract = (
        <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16.4286 3.28571H14.7143V1.57143C14.7143 1.2554 14.4589 1 14.1429 1H1.57143C1.2554 1 1 1.2554 1 1.57143V16.4286C1 16.7446 1.2554 17 1.57143 17H3.28571V18.7143C3.28571 19.0303 3.54111 19.2857 3.85714 19.2857H16.4286C16.7446 19.2857 17 19.0303 17 18.7143V3.85714C17 3.54111 16.7446 3.28571 16.4286 3.28571ZM3.28571 3.85714V15.8571H2.14286V2.14286H13.5714V3.28571H3.85714C3.54111 3.28571 3.28571 3.54111 3.28571 3.85714ZM15.8571 18.1429H4.42857V4.42857H15.8571V18.1429ZM14.1429 7.85714H6.14286V6.71429H14.1429V7.85714ZM14.1429 10.1429H6.14286V9H14.1429V10.1429ZM14.1429 12.4286H6.14286V11.2857H14.1429V12.4286ZM9 15.2857H14.1429V16.4286H9V15.2857Z" fill="#CC0033" stroke="white" stroke-width="0.2"/>
        </svg>
        
    );

    const iconPayment = (
        <svg
            fill="none"
            stroke={expandedManuItem.secund?"#cc0033":"currentColor"}
            strokeWidth="1.5"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z"
            ></path>
        </svg>
    );

    const iconLike = (
        <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
         <path d="M18.032 18.9994H0.963487C0.730432 18.9994 0.541992 18.8104 0.541992 18.5773C0.541992 16.7584 1.09794 15.2531 2.01592 14.0636C3.03749 12.739 4.50472 11.8166 6.14623 11.2949C6.29001 11.2497 6.43935 11.2849 6.54626 11.3764L6.5468 11.3759C6.91874 11.6944 7.37222 11.9522 7.88129 12.1291C8.37333 12.3004 8.9199 12.3952 9.49784 12.3952C10.0758 12.3952 10.6224 12.3004 11.1144 12.1291C11.6235 11.9522 12.077 11.6944 12.4489 11.3759C12.5707 11.2717 12.7354 11.2491 12.8748 11.3037C14.5064 11.8271 15.9631 12.7468 16.9793 14.0642C17.8972 15.2538 18.4532 16.7592 18.4532 18.5779C18.4532 18.811 18.2642 19 18.0317 19L18.032 18.9994ZM9.49761 9.85063C10.6029 9.85063 11.6041 9.40264 12.3286 8.6781C13.0532 7.95354 13.5012 6.95287 13.5012 5.84706C13.5012 4.74178 13.0532 3.74058 12.3286 3.01602C11.6041 2.29147 10.6034 1.84349 9.49761 1.84349C8.39233 1.84349 7.39113 2.29148 6.66658 3.01602C5.94202 3.74058 5.49405 4.74125 5.49405 5.84706C5.49405 6.95294 5.94204 7.95354 6.66658 8.6781C7.39113 9.40265 8.3918 9.85063 9.49761 9.85063ZM12.9248 9.27429C12.0476 10.1515 10.8359 10.6942 9.49761 10.6942C8.15923 10.6942 6.94758 10.1515 6.07043 9.27429C5.19328 8.3971 4.65104 7.18541 4.65104 5.84711C4.65104 4.50873 5.19379 3.29708 6.07043 2.41993C6.94762 1.54274 8.15931 1 9.49761 1C10.836 1 12.0476 1.54274 12.9248 2.41993C13.8019 3.29711 14.3447 4.5088 14.3447 5.84711C14.3447 7.18549 13.802 8.39713 12.9248 9.27429ZM1.39632 18.1558H17.5986C17.5209 16.7238 17.0498 15.532 16.3142 14.5782C15.4458 13.4525 14.2073 12.6487 12.8093 12.167C12.3977 12.4827 11.9183 12.7406 11.3915 12.9235C10.8075 13.1269 10.1672 13.2393 9.49781 13.2393C8.82832 13.2393 8.18807 13.1269 7.60408 12.9235C7.0773 12.7406 6.59793 12.4827 6.18636 12.167C4.78902 12.6486 3.54985 13.4525 2.68142 14.5782C1.94586 15.532 1.47421 16.7243 1.39649 18.1565L1.39632 18.1558Z" fill="#CC0033" stroke="#CC0033" stroke-width="0.3"/>
        </svg>

    );

    const iconContact = (
        <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1296 15C14.6298 15 14.1602 14.8053 13.8071 14.4519L11 11.6452L11.6935 10.9515L14.5006 13.7582C14.6686 13.9262 14.892 14.0189 15.1294 14.0189C15.367 14.0189 15.5904 13.9264 15.7584 13.7582C15.9264 13.5902 16.0191 13.3668 16.0191 13.1295C16.0191 12.8919 15.9266 12.6684 15.7584 12.5005L12.9515 9.6935L13.6451 9L16.4521 11.807C16.8055 12.1603 17 12.6299 17 13.1297C17 13.6295 16.8053 14.099 16.4519 14.4522C16.0988 14.8053 15.6292 15 15.1296 15Z" fill="#CC0033"/>
        <path d="M13.13 17C12.6303 17 12.1605 16.8056 11.8073 16.4522L9 13.645L9.69349 12.9514L12.5008 15.7587C12.6688 15.9267 12.8922 16.0191 13.13 16.0191C13.3677 16.0191 13.5911 15.9267 13.7593 15.7585C14.1058 15.412 14.1058 14.8478 13.7588 14.5008L10.9519 11.6937L11.6456 11L14.4529 13.8072C15.1822 14.5364 15.1824 15.723 14.4532 16.4522C14.0993 16.8055 13.6297 17 13.1302 17L13.13 17Z" fill="#CC0033"/>
        <path d="M11.1524 19C10.6588 19 10.1948 18.8056 9.84535 18.4525L9.78477 18.3912L10.4701 17.6975L10.5304 17.7585C10.6964 17.9265 10.9174 18.0189 11.1522 18.0189C11.3872 18.0189 11.608 17.9265 11.7739 17.7585C12.1166 17.4118 12.1163 16.8476 11.7737 16.5009L9 13.6937L9.68528 13L12.4594 15.8074C13.18 16.5367 13.1803 17.7232 12.4596 18.4524C12.1107 18.8055 11.6464 19 11.1526 19L11.1524 19Z" fill="#CC0033"/>
        <path d="M17.1305 13C16.6309 13 16.1613 12.8077 15.8077 12.4585L13.0001 9.68209L13.6937 8.99603L16.5012 11.772C16.6692 11.9381 16.8928 12.0295 17.1305 12.0295C17.3683 12.0295 17.5918 11.9381 17.7597 11.772C18.1065 11.4291 18.1063 10.8711 17.7595 10.5279L9.56751 2.42703C8.61771 1.48754 7.35472 0.970241 6.01081 0.970014C4.66765 0.970014 3.40438 1.48754 2.45431 2.42703C1.50403 3.36652 0.980941 4.61568 0.980941 5.94427C0.980941 7.27275 1.50403 8.52198 2.45408 9.46151L2.77828 9.78211L2.08474 10.4682L1.76055 10.1476C0.625102 9.02473 0 7.53199 0 5.94431C0 4.35657 0.625354 2.86393 1.76055 1.74126C2.89599 0.618414 4.40548 0 6.01077 0C7.61656 0.000242498 9.12592 0.618662 10.261 1.74126L18.453 9.84233C19.1823 10.5636 19.1823 11.7371 18.4532 12.4581C18.1001 12.8076 17.6302 12.9999 17.1304 12.9999L17.1305 13Z" fill="#CC0033"/>
        <path d="M18.1239 11L17.4611 10.2706L17.6545 10.0579C18.5629 9.05941 19.0628 7.73161 19.0626 6.31896C19.0626 4.90665 18.5626 3.57881 17.6547 2.57999C15.7806 0.518478 12.7307 0.518215 10.8562 2.57973L10.6628 2.79243L10 2.06331L10.1934 1.85061C11.2785 0.657175 12.7211 0 14.2555 0C15.7899 0 17.2325 0.65744 18.3174 1.85088C19.4024 3.04431 20 4.63129 20 6.31895C20.0002 8.00713 19.4026 9.59394 18.3172 10.7875L18.1239 11Z" fill="#CC0033"/>
        <path d="M6.85223 17C6.37794 17 5.90341 16.8193 5.54229 16.4582C5.19258 16.1084 5 15.6434 5 15.1484C5 14.6537 5.19258 14.1886 5.54229 13.8384L5.83807 13.5426C6.18778 13.1928 6.65283 13 7.14777 13C7.6427 13 8.10751 13.1926 8.45746 13.5426C8.80717 13.8923 9 14.3576 9 14.8526C9 15.3473 8.80742 15.8124 8.45796 16.1624L8.16193 16.4584C7.8008 16.8196 7.32653 17 6.85223 17ZM7.14779 13.9717C6.91248 13.9717 6.69146 14.0633 6.52511 14.2296L6.22956 14.5252C6.06321 14.6916 5.97166 14.9131 5.97166 15.1484C5.97166 15.384 6.06321 15.605 6.22933 15.7714C6.57296 16.1148 7.13177 16.115 7.47516 15.7716L7.77094 15.4758C7.93705 15.3094 8.02861 15.0882 8.02861 14.8529C8.02861 14.6173 7.93706 14.396 7.77071 14.2297C7.60412 14.0633 7.38287 13.9717 7.14779 13.9717Z" fill="#CC0033"/>
        <path d="M5.38916 15C5.03344 15 4.67755 14.8195 4.40671 14.4583C4.14444 14.1084 4 13.643 4 13.1479C4 12.6531 4.14444 12.1879 4.40671 11.8376L4.62855 11.5417C5.1704 10.8194 6.05159 10.8194 6.5931 11.5417C6.85538 11.8917 7 12.3569 7 12.852C7 13.3469 6.85556 13.8121 6.59347 14.1621L6.37164 14.458C6.1008 14.8193 5.74509 15 5.38919 15H5.38916ZM5.61082 11.9714C5.44162 11.9714 5.27242 12.0574 5.14364 12.2291L4.92197 12.5248C4.79721 12.6912 4.72855 12.9127 4.72855 13.1481C4.72855 13.3838 4.79721 13.6048 4.9218 13.7712C5.17952 14.1147 5.59881 14.1147 5.85653 13.7712L6.0782 13.4756C6.20278 13.3092 6.27145 13.0879 6.27145 12.8525C6.27145 12.6168 6.20279 12.3955 6.07803 12.2291C5.94926 12.0571 5.78005 11.9714 5.61084 11.9714H5.61082Z" fill="#CC0033"/>
        <path d="M8.85231 19C8.35735 19 7.89228 18.8071 7.54231 18.4574C7.19259 18.1076 7 17.6425 7 17.1475C7 16.6528 7.19259 16.1876 7.54206 15.8376L7.83811 15.5416C8.56039 14.8195 9.73535 14.8195 10.4574 15.5416C10.8072 15.8916 11 16.3567 11 16.8517C11 17.3464 10.8074 17.8116 10.4579 18.1616L10.1619 18.4576C9.81217 18.8071 9.3471 19 8.85237 19H8.85231ZM9.14763 15.9711C8.92201 15.9711 8.69663 16.0571 8.52493 16.2288L8.22913 16.5246C8.06302 16.691 7.97145 16.9123 7.97145 17.1476C7.97145 17.3832 8.06301 17.6042 8.22913 17.7706C8.39549 17.937 8.61674 18.0288 8.85208 18.0288C9.08742 18.0288 9.30843 17.9372 9.47478 17.7709L9.77058 17.4751C9.93669 17.3087 10.0283 17.0874 10.0283 16.852C10.0283 16.6165 9.9367 16.3952 9.77035 16.2288C9.59889 16.0568 9.37327 15.9711 9.14765 15.9711L9.14763 15.9711Z" fill="#CC0033"/>
        <path d="M2.85223 14C2.37794 14 1.90341 13.7744 1.54229 13.3229C1.19258 12.8856 1 12.3038 1 11.685C1 11.0665 1.19258 10.485 1.54229 10.0472L1.83807 9.67732C2.56055 8.77428 3.73571 8.77428 4.45771 9.67702C4.80767 10.1146 5.00025 10.6967 5 11.3158C5 11.9337 4.80742 12.5152 4.45796 12.9527L4.16218 13.3226C3.80105 13.7741 3.32678 14 2.85223 14ZM3.14827 10.2141C2.92265 10.2141 2.69681 10.3216 2.52487 10.5363L2.22931 10.9059C2.06296 11.1139 1.97141 11.3908 1.97141 11.685C1.97141 11.9795 2.06296 12.2558 2.22908 12.4639C2.57272 12.8932 3.13177 12.8932 3.4754 12.4639L3.77096 12.0943C3.93707 11.8863 4.02863 11.6097 4.02863 11.3155C4.02888 11.0206 3.93732 10.744 3.77096 10.536C3.59926 10.3213 3.37388 10.2141 3.14827 10.2141Z" fill="#CC0033"/>
        </svg>
        
    );

    const iconCalendaty = (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.66014 11.6157H3.60012C3.20012 11.6157 2.88013 11.9412 2.88013 12.348V12.4294C2.88013 12.8363 3.20012 13.1617 3.60012 13.1617H3.66014C4.06014 13.1617 4.38013 12.8363 4.38013 12.4294V12.348C4.38013 11.9412 4.06014 11.6157 3.66014 11.6157Z" fill="#CC0033"/>
            <path d="M6.58017 11.6157H6.52014C6.12014 11.6157 5.80016 11.9412 5.80016 12.348V12.4294C5.80016 12.8363 6.12014 13.1617 6.52014 13.1617H6.58017C6.98017 13.1617 7.30015 12.8363 7.30015 12.4294V12.348C7.30015 11.9412 6.98017 11.6157 6.58017 11.6157Z" fill="#CC0033"/>
            <path d="M9.52018 11.6157H9.44016C9.04016 11.6157 8.72018 11.9412 8.72018 12.348V12.4294C8.72018 12.8363 9.04016 13.1617 9.44016 13.1617H9.52018C9.92018 13.1617 10.2402 12.8363 10.2402 12.4294L10.2402 12.348C10.2402 11.9412 9.92018 11.6157 9.52018 11.6157Z" fill="#CC0033"/>
            <path d="M3.66014 8.60502H3.60012C3.20012 8.60502 2.88013 8.93048 2.88013 9.33733V9.41872C2.88013 9.82557 3.20012 10.151 3.60012 10.151H3.66014C4.06014 10.151 4.38013 9.82557 4.38013 9.41872V9.33733C4.38013 8.93048 4.06014 8.60502 3.66014 8.60502Z" fill="#CC0033"/>
            <path d="M6.58017 8.60502H6.52014C6.12014 8.60502 5.80016 8.93048 5.80016 9.33733V9.41872C5.80016 9.82557 6.12014 10.151 6.52014 10.151H6.58017C6.98017 10.151 7.30015 9.82557 7.30015 9.41872V9.33733C7.30015 8.93048 6.98017 8.60502 6.58017 8.60502Z" fill="#CC0033"/>
            <path d="M9.52018 8.60502H9.44016C9.04016 8.60502 8.72018 8.93048 8.72018 9.33733V9.41872C8.72018 9.82557 9.04016 10.151 9.44016 10.151H9.52018C9.92018 10.151 10.2402 9.82557 10.2402 9.41872V9.33733C10.2402 8.93048 9.92018 8.60502 9.52018 8.60502Z" fill="#CC0033"/>
            <path d="M12.4402 11.6157H12.3601C11.9601 11.6157 11.6402 11.9412 11.6402 12.348V12.4294C11.6402 12.8363 11.9601 13.1617 12.3601 13.1617H12.4402C12.8402 13.1617 13.1601 12.8363 13.1601 12.4294V12.348C13.1801 11.9412 12.8402 11.6157 12.4402 11.6157Z" fill="#CC0033"/>
            <path d="M15.3801 11.6157H15.3001C14.9001 11.6157 14.5801 11.9412 14.5801 12.348V12.4294C14.5801 12.8363 14.9001 13.1617 15.3001 13.1617H15.3801C15.7801 13.1617 16.1001 12.8363 16.1001 12.4294V12.348C16.1001 11.9412 15.7801 11.6157 15.3801 11.6157Z" fill="#CC0033"/>
            <path d="M12.4402 8.60502H12.3601C11.9601 8.60502 11.6402 8.93048 11.6402 9.33733V9.41872C11.6402 9.82557 11.9601 10.151 12.3601 10.151H12.4402C12.8402 10.151 13.1601 9.82557 13.1601 9.41872V9.33733C13.1801 8.93048 12.8402 8.60502 12.4402 8.60502Z" fill="#CC0033"/>
            <path d="M15.3801 8.60502H15.3001C14.9001 8.60502 14.5801 8.93048 14.5801 9.33733V9.41872C14.5801 9.82557 14.9001 10.151 15.3001 10.151H15.3801C15.7801 10.151 16.1001 9.82557 16.1001 9.41872V9.33733C16.1001 8.93048 15.7801 8.60502 15.3801 8.60502Z" fill="#CC0033"/>
            <path d="M3.66014 14.6061H3.60012C3.20012 14.6061 2.88013 14.9315 2.88013 15.3384V15.4198C2.88013 15.8266 3.20012 16.1521 3.60012 16.1521H3.66014C4.06014 16.1521 4.38013 15.8266 4.38013 15.4198V15.3384C4.38013 14.9519 4.06014 14.6061 3.66014 14.6061Z" fill="#CC0033"/>
            <path d="M6.58017 14.6061H6.52014C6.12014 14.6061 5.80016 14.9315 5.80016 15.3384V15.4198C5.80016 15.8266 6.12014 16.1521 6.52014 16.1521H6.58017C6.98017 16.1521 7.30015 15.8266 7.30015 15.4198V15.3384C7.30015 14.9519 6.98017 14.6061 6.58017 14.6061Z" fill="#CC0033"/>
            <path d="M9.52018 14.6061H9.44016C9.04016 14.6061 8.72018 14.9315 8.72018 15.3384V15.4198C8.72018 15.8266 9.04016 16.1521 9.44016 16.1521H9.52018C9.92018 16.1521 10.2402 15.8266 10.2402 15.4198V15.3384C10.2402 14.9519 9.92018 14.6061 9.52018 14.6061Z" fill="#CC0033"/>
            <path d="M12.4402 14.6061H12.3601C11.9601 14.6061 11.6402 14.9315 11.6402 15.3384V15.4198C11.6402 15.8266 11.9601 16.1521 12.3601 16.1521H12.4402C12.8402 16.1521 13.1601 15.8266 13.1601 15.4198V15.3384C13.1801 14.9519 12.8402 14.6061 12.4402 14.6061Z" fill="#CC0033"/>
            <path d="M15.3801 14.6061H15.3001C14.9001 14.6061 14.5801 14.9315 14.5801 15.3384V15.4198C14.5801 15.8266 14.9001 16.1521 15.3001 16.1521H15.3801C15.7801 16.1521 16.1001 15.8266 16.1001 15.4198V15.3384C16.1001 14.9519 15.7801 14.6061 15.3801 14.6061Z" fill="#CC0033"/>
            <path d="M18.9802 6.22491V4.57718C18.9802 3.31597 17.9802 2.29881 16.7602 2.29881H15.5801V1.58682C15.5801 0.712057 14.8801 6.62193e-05 14.0201 6.62193e-05C13.1601 6.62193e-05 12.4601 0.712057 12.4601 1.58682V2.29881L6.54008 2.29874V1.58675C6.54008 0.71199 5.84008 0 4.98005 0C4.12002 0 3.42002 0.71199 3.42002 1.58675V2.29874H2.24C1.00003 2.29874 0 3.31587 0 4.57711V16.742C0 17.9829 1 19 2.24 19H16.78C18 19 19 17.9829 19 16.742L18.9802 6.22491ZM13.3802 1.5868C13.3802 1.24101 13.6602 0.956201 14.0001 0.956201C14.3401 0.956201 14.6201 1.24101 14.6201 1.5868V3.09217C14.6201 3.43796 14.3401 3.72277 14.0001 3.72277C13.6602 3.72277 13.3802 3.43796 13.3802 3.09217V1.5868ZM4.34017 1.5868C4.34017 1.24101 4.62018 0.956201 4.96015 0.956201C5.30012 0.956201 5.58013 1.24101 5.58013 1.5868V3.09217C5.58013 3.43796 5.30012 3.72277 4.96015 3.72277C4.62018 3.72277 4.34017 3.43796 4.34017 3.09217V1.5868ZM2.22017 3.25493H3.42017C3.50018 4.04831 4.16013 4.67891 4.9802 4.67891C5.7802 4.67891 6.44023 4.04831 6.52017 3.25493H12.4602C12.5402 4.04831 13.2001 4.67891 14.0001 4.67891C14.8001 4.67891 15.4602 4.04831 15.5401 3.25493H16.7401C17.4401 3.25493 18.0201 3.84488 18.0201 4.5772V5.7571L0.920117 5.75703V4.57713C0.920117 3.84481 1.50018 3.25493 2.22017 3.25493ZM16.7602 18.044H2.22017C1.50018 18.044 0.920167 17.454 0.920167 16.742V6.69281H18.0402V16.742C18.0402 17.454 17.4602 18.044 16.7602 18.044Z" fill="#CC0033"/>
        </svg>
        
    );
    useEffect(()=>{
     
        // pulpit: true,
        // first: false,
        // secund: false,
        // third: false,
        // fourth: false,
        if(props.nav == "/Pulpit"){
            setExpandedManuItem({
                pulpit: true,
                first: false,
                secund: false,
                third: false,
                fourth: false,
            });
        }else if(props.nav == "/Payment_history"||props.nav == "/To_pay"){
            setExpandedManuItem({
                pulpit: false,
                first: true,
                secund: false,
                third: false,
                fourth: false,
            })
        }
        else if(props.nav == "/Courses"||props.nav == "/Events"||props.nav == "/Workshops"||props.nav == "/Departures"){
            setExpandedManuItem({
                pulpit: false,
                first: false,
                secund: true,
                third: false,
                fourth: false,
            })
        }else if(props.nav == "/Current_classes"||props.nav == "/Todo_classes"){
           
            setExpandedManuItem({
                pulpit: false,
                first: false,
                secund: false,
                third: true,
                fourth: false,
            })
        }else if(props.nav == "/Customer_service"||props.nav == "/Maps"||props.nav == "/FAQ"){
            setExpandedManuItem({
                pulpit: false,
                first: false,
                secund: false,
                third: false,
                fourth: true,
            })
        }
    },[])

    return (
        <>
            <nav className="dashboard__mobile-nav">
                <button
                    className="dashboard__hamburger-btn"
                    id="manuNarrow"
                    onClick={(e) => {
                        document.getElementById('manuNarrow').style.display = 'none';
                        document.getElementById('manuWide').style.display = 'flex';
                    }}
                >
                    <svg
                        className="dashboard__hamburger-icon"
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path d="M5.33333 8H26.6667V10.6667H5.33333V8ZM5.33333 14.6667H26.6667V17.3333H5.33333V14.6667ZM5.33333 21.3333H26.6667V24H5.33333V21.3333Z" />
                    </svg>
                </button>
            </nav>
            <nav className="dashboard__nav dashboard__nav--hidden" id="manuWide">
                <div className="dashboard__close-nav-btn-box ">
                    <div className="backButton">
                    <button
                        className="dashboard__close-nav-btn"
                        onClick={(e) => {
                            document.getElementById('manuNarrow').style.display = 'block';
                            document.getElementById('manuWide').style.display = 'none';
                        }}
                    >
                       <svg class="dashboard__btn-chevron  " style={{transform:" rotate(0.25turn)"}} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6 9L12 15L18 9" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
                    
                    </button>
                    <p>ZWIŃ</p>
                </div></div>
                <ul className="dashboard__menu">
                    <MenuHeadItem
                    key="MenuHeadItem1"
                        tittle={{
                            head: 'Pulpit',
                            navigatorLine: '/Pulpit',
                        }}
                        expand={true}
                        icon={iconMyData}
                        isShowArrow={props.nav}
                        showArrow={props.setNav}
                        expandedManuItem={expandedManuItem.pulpit}
                        setExpandedManuItem={() => {
                            props.setNav("/Pulpit")
                            setExpandedManuItem({
                                pulpit: true,
                                first: false,
                                secund: false,
                                third: false,
                                fourth: false,
                            });
                        }}
                    />
                    <MenuHeadItem
                    key="MenuHeadItem2"
                        tittle={{
                            head: 'Faktury i płatności',
                            line: {
                                first: ['Do zapłaty', '/To_pay'],
                                second: ['Historia płatności', '/Payment_history'],
                            },
                        }}
                        expand={true}
                        icon={iconContract}
                        expandedManuItem={expandedManuItem.first}
                        setExpandedManuItem={() => {
                            if(expandedManuItem.first){
                                setExpandedManuItem({
                                    pulpit: false,
                                    first: false,
                                    secund: false,
                                    third: false,
                                    fourth: false,
                                });
                            }else{
                            setExpandedManuItem({
                                pulpit: false,
                                first: true,
                                secund: false,
                                third: false,
                                fourth: false,
                            });
                            history.push("/To_pay")}
                        }}
                        setInside={() => {
                            setExpandedManuItem({
                                pulpit: false,
                                first: true,
                                secund: false,
                                third: false,
                                fourth: false,
                            })}
                        }
                        isShowArrow={props.nav}
                        showArrow={props.setNav}
                    />
                    <MenuHeadItem
                    key="MenuHeadItem3"
                        tittle={{
                            head: 'Dla ciebie',
                            line: {
                                first: ['Kursy', '/Courses'],
                                secund: ['Eventy', '/Events'],
                                third: ['Warsztaty', '/Workshops'],
                                fourth: ['Wyjazdy', '/Departures'],
                            },
                        }}
                        expand={false}
                        icon={iconLike}
                        expandedManuItem={expandedManuItem.secund}
                        setExpandedManuItem={() => {
                            if(expandedManuItem.secund){
                                setExpandedManuItem({
                                    pulpit: false,
                                    first: false,
                                    secund: false,
                                    third: false,
                                    fourth: false,
                                });

                            }else{
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: true,
                                third: false,
                                fourth: false,
                            });
                            history.push("/Courses")
                        }
                        }}
                        setInside={() => {
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: true,
                                third: false,
                                fourth: false,
                            })}
                        }
                        isShowArrow={props.nav}
                        showArrow={props.setNav}
                    />
                    <MenuHeadItem
                    key="MenuHeadItem4"
                        tittle={{
                            head: 'Kalendarz zajęć',
                            line: {
                                first: ['Mój kalendarz', '/Current_classes'],
                                secund: ['Odwołanie/odrabianie zajęć', '/Todo_classes'],
                            },
                        }}
                        expand={false}
                        icon={iconCalendaty}
                        expandedManuItem={expandedManuItem.third}
                        setExpandedManuItem={() => {
                            if(expandedManuItem.third){
                                setExpandedManuItem({
                                    pulpit: false,
                                    first: false,
                                    secund: false,
                                    third: false,
                                    fourth: false,
                                });
                            }else{
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: false,
                                third: true,
                                fourth: false,
                            });
                            history.push("/Current_classes")}
                        }}
                        setInside={() => {
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: false,
                                third: true,
                                fourth: false,
                            })}
                        }
                        isShowArrow={props.nav}
                        showArrow={props.setNav}
                    />
                    <MenuHeadItem
                    key="MenuHeadItem5"
                        tittle={{
                            head: 'Pomoc i kontakt',
                            line: {
                                first: ['Obsługa klienta', '/Customer_service'],
                                secund: ['Szkoły', '/Maps'],
                                third: ['FAQ', '/FAQ'],
                            },
                        }}
                        expand={false}
                        icon={iconContact}
                        expandedManuItem={expandedManuItem.fourth}
                        setExpandedManuItem={() => {
                            if(expandedManuItem.fourth){
                                setExpandedManuItem({
                                    pulpit: false,
                                    first: false,
                                    secund: false,
                                    third: false,
                                    fourth: false,
                                });
                            }else{
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: false,
                                third: false,
                                fourth: true,
                            });
                            history.push("/Customer_service")}
                        }}
                        setInside={() => {
                            setExpandedManuItem({
                                pulpit: false,
                                first: false,
                                secund: false,
                                third: false,
                                fourth: true,
                            })}
                        }
                        isShowArrow={props.nav}
                        showArrow={props.setNav}
                    />
                </ul>
            </nav>
        </>
    );
};

export default Menu;
